import { hasHiddenParent } from "./visibility.js";
import { isDesktopUp } from "./is-media.js";
const moveBackdrop = (parent, target, isAlreadyVisible) => {
  const transition = isAlreadyVisible ? ".5s cubic-bezier(.75,0,0,1)" : "opacity .5s ease, visibility 0s 0s";
  parent.style.setProperty("--tds-animate-backdrop-transition", transition);
  parent.style.setProperty("--tds-animate-backdrop-opacity", "1");
  parent.style.setProperty("--tds-animate-backdrop-visibility", "inherit");
  if (target) {
    const { offsetHeight, offsetLeft, offsetTop, offsetWidth } = target;
    parent.style.setProperty("--tds-animate-backdrop-top", `${offsetTop}px`);
    parent.style.setProperty("--tds-animate-backdrop-left", `${offsetLeft}px`);
    parent.style.setProperty("--tds-animate-backdrop-height", `${offsetHeight}px`);
    parent.style.setProperty("--tds-animate-backdrop-width", `${offsetWidth}px`);
  }
};
const hideBackdrop = (parent) => {
  parent.style.setProperty(
    "--tds-animate-backdrop-transition",
    "opacity .5s ease, visibility 0s .5s"
  );
  parent.style.setProperty("--tds-animate-backdrop-opacity", "0");
  parent.style.setProperty("--tds-animate-backdrop-visibility", "hidden");
};
const animateBackdrop = (parent) => {
  const targetElements = [...parent.querySelectorAll(".tds-animate--backdrop")];
  const desktopUp = isDesktopUp();
  let isVisible = false;
  const handleMouseEnter = (e) => {
    moveBackdrop(parent, e.target, isVisible);
    isVisible = true;
  };
  const smoothReset = () => {
    const highlightedElement = parent.querySelector(".tds--highlighted");
    if (highlightedElement && !hasHiddenParent(highlightedElement) && desktopUp) {
      moveBackdrop(parent, highlightedElement, isVisible);
      isVisible = true;
    } else {
      hideBackdrop(parent);
      isVisible = false;
    }
  };
  const hardReset = () => {
    const highlightedElement = parent.querySelector(".tds--highlighted");
    if (highlightedElement && !hasHiddenParent(highlightedElement) && desktopUp) {
      moveBackdrop(parent, highlightedElement, false);
      isVisible = true;
    } else {
      hideBackdrop(parent);
      isVisible = false;
    }
  };
  hardReset();
  targetElements.forEach((element) => {
    element.addEventListener("mouseenter", handleMouseEnter);
  });
  window.addEventListener("resize", hardReset);
  parent.addEventListener("mouseleave", smoothReset);
  document.fonts?.addEventListener("loadingdone", hardReset);
  return () => {
    targetElements.forEach((element) => {
      element.removeEventListener("mouseenter", handleMouseEnter);
    });
    window.removeEventListener("resize", hardReset);
    parent.removeEventListener("mouseleave", smoothReset);
    document.fonts?.removeEventListener("loadingdone", hardReset);
  };
};
export {
  animateBackdrop,
  hideBackdrop,
  moveBackdrop
};
